export default "__VITE_ASSET__CmZX84GP__"